export const supervisorQueueMessagesEn = {
  'supervisorQueue.header.title': 'Encounters',
  'supervisorQueue.header.stats.total.title': 'Total',
  'supervisorQueue.header.stats.pendingByBoth.title': 'Pending by both annotators',
  'supervisorQueue.header.stats.completed.title': 'Completed',
  'supervisorQueue.header.stats.finalizedByOne.title': 'Finalized by 1 annotator',
  'supervisorQueue.header.stats.finalizedByBoth.title': 'Finalized by both (conflicts pending)',
  'supervisorQueue.header.stats.draft.title': 'Draft',
  'supervisorQueue.content.table.status.conflicts_pending': 'Conflicts pending',
  'supervisorQueue.content.table.status.completed': 'Completed',
  'supervisorQueue.content.table.status.finalized_a2': 'Finalized A2',
  'supervisorQueue.content.table.status.finalized_a1': 'Finalized A1',
  'supervisorQueue.content.table.status.pending': 'Pending',
  'supervisorQueue.content.table.status.draft': 'Draft',
  'supervisorQueue.demarkation.adminAsSupervisorForProject':
    'You are assigned as a Supervisor for this project. Encounters will open in full editing mode.',
};
